/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Mock_Rule2_ActionInputs */

const tr_landing_pricerules_mock_rule2_action = /** @type {(inputs: Landing_Pricerules_Mock_Rule2_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seçtiğiniz bildirim kanallarından yeni fiyat önerisi`)
};

const en_landing_pricerules_mock_rule2_action = /** @type {(inputs: Landing_Pricerules_Mock_Rule2_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New price proposal through your chosen notification channels`)
};

const de_landing_pricerules_mock_rule2_action = /** @type {(inputs: Landing_Pricerules_Mock_Rule2_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Preisvorschlag über die gewählten Benachrichtigungskanäle`)
};

const ru_landing_pricerules_mock_rule2_action = /** @type {(inputs: Landing_Pricerules_Mock_Rule2_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новое предложение цены по выбранным каналам уведомлений`)
};

/**
* | output |
* | --- |
* | "New price proposal through your chosen notification channels" |
*
* @param {Landing_Pricerules_Mock_Rule2_ActionInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_mock_rule2_action = /** @type {((inputs?: Landing_Pricerules_Mock_Rule2_ActionInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Mock_Rule2_ActionInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_mock_rule2_action(inputs)
	if (locale === "de") return de_landing_pricerules_mock_rule2_action(inputs)
	if (locale === "ru") return ru_landing_pricerules_mock_rule2_action(inputs)
	return tr_landing_pricerules_mock_rule2_action(inputs)
});